"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Renderer = exports.SectionRenderer = exports.renderers = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const ui_1 = require("@obvio/ui");
const Columns_1 = require("./Columns");
const defaults_1 = require("./defaults");
const Rows_1 = require("./Rows");
var defaults_2 = require("./defaults");
Object.defineProperty(exports, "renderers", { enumerable: true, get: function () { return defaults_2.renderers; } });
function SectionRenderer({ data: { component, variant, data }, customRenderers, section = ui_1.Section, }) {
    var _a, _b;
    const combinedRenderers = Object.assign(Object.assign({}, (0, defaults_1.renderers)(section)), customRenderers);
    const fullName = `${component}.${variant}`;
    const renderer = (_b = (_a = combinedRenderers[fullName]) !== null && _a !== void 0 ? _a : combinedRenderers[variant]) !== null && _b !== void 0 ? _b : combinedRenderers[component];
    if (!renderer) {
        return null;
    }
    return renderer(data);
}
exports.SectionRenderer = SectionRenderer;
function Renderer({ data, customRenderers, section, }) {
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: data.map((sectionData, index) => ((0, jsx_runtime_1.jsx)(SectionRenderer, { section: section, customRenderers: customRenderers, data: sectionData }, index))) }));
}
exports.Renderer = Renderer;
Renderer.Rows = Rows_1.Rows;
Renderer.Columns = Columns_1.Columns;
